export class RandomGenerator {
  seed: number;

  constructor(seed = 123456789) {
    this.seed = seed;
  }

  public generate() {
    this.seed = (this.seed * 16807) % 2147483647;
  }

  public next(): number {
    this.generate();

    // seed will be 1 to 2147483646 (inclusive).
    return (this.seed - 1) / 2147483646;
  }

  public nextInt(highLimit: number): number {
    this.generate();

    return (this.seed - 1) % highLimit;
  }
}

export default RandomGenerator;
